import { useState, useEffect } from 'react';
import { Burger, Container, Group, Switch, useMantineColorScheme, Menu } from '@mantine/core';
import { IconSun, IconMoonStars, IconLogout, IconLogin, IconUser } from '@tabler/icons-react';
import { useDisclosure } from '@mantine/hooks';
import { useAuthHook } from '../hooks/auth.hooks.tsx';
import classes from './style.module.css';
import { useLocation } from 'wouter';
import myYentaHeader from '@/assets/my_yenta_header.png';
import cx from 'clsx';

export function HeaderSimple() {
  const { isAuthenticated, signout, injectHeader } = useAuthHook();
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const links = [
    { link: '/', label: 'About' },
    { link: '/status', label: 'Status' },
    { link: '/dashboard', label: 'Dashboard', auth: true },
    { link: '/support', label: 'Support', auth: true },
    { link: '/login', label: isAuthenticated ? 'Sign Out' : 'Sign In', icon: isAuthenticated ? IconLogout : IconLogin, burgerIcon: IconUser }
  ];
  const [opened, { toggle }] = useDisclosure(false);
  const [active, setActive] = useState(links[0].link);
  const [path, navigate] = useLocation();

  useEffect(() => {
    setActive(path);
  }, [path]);

  const authCheck = async () => {
    const rr = new Request('api/auth/check');
    injectHeader(rr);
    const res = await fetch(rr);
    const data = await res.json() as { msg: string };
    console.log('data', data);
  }

  function themeSwitch() {
    return (
      <Switch
        size="md"
        color="dark.4"
        onLabel={<IconSun size={16} stroke={2.5} color="var(--mantine-color-yellow-4)" />}
        offLabel={<IconMoonStars size={16} stroke={2.5} color="var(--mantine-color-blue-6)" />}
        checked={colorScheme === 'dark'}
        onChange={() => setColorScheme(colorScheme === 'dark' ? 'light' : 'dark')}
      />

    );
  }

  const items = links.filter(link => !!link.auth ? isAuthenticated : true).map((link) => (
    <a
      key={link.label}
      className={cx(classes.link, link.link === '/login' && classes.linkEntry)}
      data-active={active === link.link || undefined}
      onClick={(event) => {
        event.preventDefault();
        setActive(link.link);
        if (link.auth && !isAuthenticated) {
          navigate('/login');
        } else if (link.link === '/login' && isAuthenticated) {
          signout();
          navigate('/login');
        } else {
          navigate(link.link);
        }
      }}
    >
      {link.icon && <link.icon size={16} />}
      {link.label}
    </a>
  ));

  return (
    <div className={classes.header}>
      <Container size="md" className={classes.inner}>
        <img src={myYentaHeader} alt='My Yenta' className={classes.logo} onClick={authCheck} />
        <Group gap={5} visibleFrom="sm">
          {items}
          {themeSwitch()}
        </Group>
        <Menu withinPortal={false} offset={8} withOverlay={true}>
          <Menu.Target>
            <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
          </Menu.Target>
          <Menu.Dropdown style={{ right: 30, left: 'auto' }}>
            { links.filter(ll => ll.link !== '/login').filter(link => !!link.auth ? isAuthenticated : true).map((link) => (
              <Menu.Item 
                key={link.label} 
                onClick={() => navigate(link.link)} 
                leftSection={link.burgerIcon && <link.burgerIcon size={16} />}
                rightSection={link.icon && <link.icon size={16} />}
              >
                {link.label}
              </Menu.Item>
            ))}
            <Menu.Divider />
            <Menu.Item rightSection={themeSwitch()}>
              Theme Mode
            </Menu.Item>
            <Menu.Divider />
            <Menu.Label> Account Area</Menu.Label>
            { links.filter(ll => ll.link === '/login').map((link) => (
              <Menu.Item 
                key={link.label} 
                color={isAuthenticated ? 'red' : 'blue'}
                onClick={() => navigate(link.link)} 
                leftSection={link.burgerIcon && <link.burgerIcon size={16} />}
                rightSection={link.icon && <link.icon size={16} />}
              >
                {link.label}
              </Menu.Item>
            ))}
          </Menu.Dropdown>
        </Menu>
      </Container>
    </div>
  );
}